module.exports = __webpack_public_path__ + "images/fa-lp-sl-m-antoniya-baltova-mobile.webp";